import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { CardTitle } from 'screens/Home/components/CardComponents'
import { Button, Card } from '@lmc/ui-kit'
import { Spinner } from 'components/generic'
import { useTranslation } from 'react-i18next'
import useTodayMonitoring from 'screens/Rostering/hooks/useTodayMonitoring'
import EventCount from './components/EventCount'
import UnpublishedWarning from '../components/UnpublishedWarning'

const MonitoringHomeCard = () => {
  const { t } = useTranslation()

  const { todayMonitoring, isTodayMonitoringLoading } = useTodayMonitoring()

  if (!todayMonitoring?.statusSummary) return null

  return (
    <CardStyled className="lmc-home-card">
      <CardContent>
        <Link to="rota/monitoring">
          <CardTitle title={t('PUBLISHED_ROTA')} />
        </Link>
        {isTodayMonitoringLoading ? (
          <Spinner />
        ) : (
          <Content className="lmc-home-card-body-ss">
            {todayMonitoring.statusSummary?.unPublishedChanges > 0 && (
              <UnpublishedWarning
                events={todayMonitoring?.statusSummary?.unPublishedChanges}
                slim
              />
            )}

            <Container>
              {Object.entries(todayMonitoring?.statusSummary?.statuses).map(
                ([key, value]) => (
                  <EventCount key={key} type={key} count={value as number} />
                )
              )}
            </Container>
          </Content>
        )}
      </CardContent>

      <Buttons className="lmc-home-card-footer">
        <Link to="rota/builder">
          <Button>{t('VIEW_ALL')}</Button>
        </Link>
        <Link to="rota/monitoring">
          <Button variant="primary">{t('MONITORING_DASHBOARD')}</Button>
        </Link>
      </Buttons>
    </CardStyled>
  )
}

const CardStyled = styled(Card)`
  padding: 24px 24px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Container = styled.div`
  width: fit-content;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 48px;
  row-gap: 8px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: fit-content;
`
const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`

export default MonitoringHomeCard
